import { readContract, } from "wagmi/actions";
import { wagmiConfig, } from "@config";
import * as contracts from "@contracts";
import moment from "moment";
import { type Address, } from "@bracket/addressbook";
import {
	getBalance,
} from "wagmi/actions";

export const getEthereumBalance = async ({
	wallet,
	attempt = 0,
	force = false,
}: {
	wallet: Address;
	attempt?: number;
	force?: boolean;
}): Promise<bigint> => {

	try {
		const now = moment().unix();
		const cached = ethereumBalanceCache.get("ETH");
		if(!force) {
			if( cached ) {
				const { since, value, } = cached;
				if(now - since < ethereumBalanceTTL) {
					return value;
				}
			}
		}

		const result = await getBalance(wagmiConfig, { address: wallet, });
		if(result && typeof result.value === "bigint") {
			ethereumBalanceCache.set("ETH", { since: now, value: result.value, });
			return result.value;
		}
		throw new Error("expected a bigint result");
	}
	catch(err) {
		if(attempt < 3) {
			return await getEthereumBalance({ wallet, attempt: attempt + 1, force, });
		}
		throw new Error(`EscrowStore::getEthereumBalance, failed after ${attempt} attempts - ${err instanceof Error ? err.message : "no error instance"}`)
	}
};


const ethereumBalanceCache = new Map<"ETH", { since: number, value: bigint, }>();
const ethereumBalanceTTL = 15;
